import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { InputErrorMassage, PasswordInput } from '../comps/comps'
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa'
import { getSignupDraft, setSignupDraft } from '../utils/signupDraft'

const AuthPassword = () => {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [passwordEye, setPasswordEye] = useState(true)
  const [tried, setTried] = useState(false)

  useEffect(() => {
    const draft = getSignupDraft()
    if (!draft.email) navigate('/auth', { replace: true })
    if (!draft.emailVerified && !draft.social) navigate('/auth/setup/code', { replace: true })
    if (draft.password) setPassword(draft.password)
  }, [navigate])

  const next = () => {
    setTried(true)
    if (password.length !== 10) return
    setSignupDraft({ password })
    navigate('/auth/setup/name')
  }

  return (
    <AuthShell title="Create password">
      <p className="authStepLabel">Create a password</p>
      <PasswordInput
        show={<FaRegEyeSlash />}
        showed={<FaRegEye />}
        passwordEyeAction={() => setPasswordEye(prev => !prev)}
        eye={passwordEye}
        placeholder="Enter Your Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      {tried && <InputErrorMassage val={password} num={[10, 10]} text="password should be 10 letters" />}
      <button type="button" className="googlebuttons" onClick={next}>Next</button>
      <p className="googlebuttonss" onClick={() => navigate('/auth')}>Back</p>
    </AuthShell>
  )
}

export default AuthPassword
